import { QueryOrigin, RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class SetOriginMutation implements RecommendationsMutation {
  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.setOrigin]: (localState: RecommendationsState, origin: QueryOrigin) => {
      localState.origin = origin;
    }
  };
}
